import axiosInstance from "../../config/axiosInstance";

export const getCompaniesRequest = async () => {
    return await axiosInstance.dillApi().get("/companies");
};

